import {
    http,
} from '../services';

class TipoApresentacaoService {

    tipoApresentacaoForm() {
        return http.get('/tiposapresentacao/form');
    }

    async getTiposApresentacao(subevento) {
        return http.get('/tiposapresentacao', {
            subevento,
        });
    }


    getTipoApresentacao(codigo) {
        return http.get(`/tiposapresentacao/${codigo}`);
    }

    save(tipoapresentacao) {
        return http.post('/tiposapresentacao', tipoapresentacao);
    }

    update(tipoapresentacao) {
        return http.put('/tiposapresentacao', tipoapresentacao);
    }

    delete(tipoapresentacao) {
        return http.delete('/tiposapresentacao', tipoapresentacao);
    }
}

const tipoApresentacaoService = new TipoApresentacaoService();
export default tipoApresentacaoService;